import { TProductCode } from '@/shared/types/product-types'

export const getOrderUrl = (
	productIds: Array<number | undefined>,
	productCode?: TProductCode,
	orderQuery: Record<string, string> = {}
) => {
	const pathname = `/order/${productIds.filter((id): id is number => id !== undefined).join(',')}`
	const query = new URLSearchParams(orderQuery)
	if (productCode) query.set('kod', String(productCode))
	const search = query.toString()

	return search ? `${pathname}?${search}` : pathname
}
